module.exports = __webpack_public_path__ + "static/img/nodata.47f2666.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Search/nodata.svg
// module id = l3Jb
// module chunks = 1